export const PM_CHANGE_MASTER_ALL_ACTIONS = {
    A: 'add',
    R: 'remove'
};
